import {
	appealsConstants
}from './constants'
import {
	exportToExcelConstants
}from '../../ExportToExcel/store/constans'
import api from './api'
import {
	uploadFileConstants
}from '../../UploadFile/constants'
import {
	defAction
}from '../../../helpers/defaultAction'
import {
	request, success, failure
}from '../../../helpers/dispatchFunctions'

import downloadFile from '../../../helpers/downloadFile'

export const appealsActions = {
	setToCloseAddressForm,
	clearWCAppeal,
	clearAddresSearchField,
	setBackUrl,
	setFilter,
	setFilters,
	setResHV,
	setTrHV,
	exportToExcel,
	CreateAppeal,
	getListRA,
	getListPrevAppeals,
	ClearCreateResult,
	GetListAppeal,
	GetAppealById,
	UploadFiles,
	ClearUploadFielIds,
	GetMinReOrgAppealInfoByAppealId,
	ClearMinReOrgAppealInfoByAppealId,
	GetAppealFilesByAppealId,
	DownloadAppealFile,
	DownloadAllAppealFiles,
	DownloadAppealAnswerFile,
	ClearAppealFilesByAppealId,
	setRARegForm,
	GetRAById,
	GetRA_AById,
	regAppeal,
	getListPrevAppealsForDisciplinaryActions,
	recallAppeal,
	withoutConsiderationAppeal,
	redirectAppeal,
	clearRedirectAppeal,
	gerRedirectRAs,
	finaliseAppeal,
	editReviewProcess,
	checkPreviousAppeal,
	CreateOrgAppeal,
	EditElectronicOrgAppeal,
	EditOrgAppeal,
	ClearResult,
	GetAnswerFilesByAppealId,
	ClearAnswerFilesByAppealId,
	GetAppealChangeHistory,
	ClearGetAppealById,
	setDefaultPage,
	downloadAppealTransferTransmittalFile,
	ClearGetListRa,
	getHeadViceOrg,
	createRedirectAppealForm,
	createAppealRequestForm,
	createAppealResponseForm,
	getAppealRequestForms,
	getAppealRequestFormsPaged,
	downloadAppealRequestFormFile,
	clearCreateRequestForm,
	changeRedirectAppealForm,
	getRedirectAppealForms,
	downloadRedirectAppealFormFile,
	redirectAppealFromForm,
	excelFileClear,
	GetRepeatAppeals,
	ClearRepeatAppeals,
	GetRedirectedFilesInfo,
	takeIntoAccount,
	clearTakeIntoAccount,
	getRecallByRegistratorFiles,
	clearRecallByRegistratorFiles,
	recallByRegistrator,
	clearRecallByRegistrator,
	downloadRecallBasisFile,
	getReOrgAppealConvertFile,
	clearConvertFile,
	getRedirectAccompanyingLetterFile,
	clearAccompanyingLetterFile,
	clearRedirectAppealFromForm,
	getPotentialOrgAppealTerritories,
	clearPotentialReOrgAppealTerritories,
	getAllReOrgAppealTerritories,
	downloadAdditionalOrderMessageFiles,
	downloadAdditionalOrderMessageFile,
	ClearFileUploadChange,
	ClearRecallAppeal,
	ClearReOrgAppeal,
	generateTransmittalLetterFile
}

function GetRedirectedFilesInfo(params){
	const dispatchObj = {
		constants : appealsConstants.GetRedirectedFilesInfo,
		service   : {
			func   : api.GetRedirectedFilesInfo,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function ClearFileUploadChange(){
	return (dispatch) => dispatch({ type: appealsConstants.ClearFileUploadChange })
}

function exportToExcel(tableIndex){
	const serverParams = {
		tableIndex: tableIndex
	}

	const dispatchObj = {
		constants : exportToExcelConstants.ExportListToExcel,
		service   : {
			func   : api.ExportListToExcel,
			params : (store) => {
				return {
					...serverParams,
					...store.filters.pagination,
					...store.filters.filters,
					...store.filters.sorter
				}
			}
		}
	}

	return defAction(dispatchObj)
}

function setToCloseAddressForm(params){
	return (dispatch) => dispatch({ type    : appealsConstants.SET_TO_CLOSE_ADDRESS_FORM,
		payload : params })
}

function clearAddresSearchField(params){
	return (dispatch) => dispatch({ type    : appealsConstants.CLEAR_ADDRESS_SEARCH_FIELD,
		payload : params })
}


function setBackUrl(params){
	return (dispatch) => dispatch({ type    : appealsConstants.SET_BACK_URL,
		payload : params })
}

function setFilter(params){
	return (dispatch) => dispatch({ type    : appealsConstants.SET_FILTER,
		payload : params })
}

function setFilters(params){
	return (dispatch) => dispatch({ type    : appealsConstants.SET_FILTERS,
		payload : params })
}

function setResHV(){
	return (dispatch) => dispatch({ type: appealsConstants.SET_RH })
}

function setTrHV(){
	return (dispatch) => dispatch({ type: appealsConstants.SET_TH })
}

function setDefaultPage(){
	return (dispatch) => dispatch({ type: appealsConstants.SET_DEFAULT_PAGE })
}

function ClearResult(){
	return (dispatch) => dispatch({ type: appealsConstants.FinaliseAppeal.CLEAR })
}

function ClearGetListRa(){
	return (dispatch) => dispatch({ type: appealsConstants.getListRA.CLEAR })
}
function clearCreateRequestForm(){
	return (dispatch) => dispatch({ type: appealsConstants.CreateAppealRequestForm.CLEAR })
}

function clearRedirectAppeal(){
	return (dispatch) => dispatch({ type: appealsConstants.RedirectAppeal.CLEAR })
}

function ClearRecallAppeal(){
	return (dispatch) => dispatch({ type: appealsConstants.RecallAppeal.CLEAR })
}

function UploadFiles(){
	return (dispatch, getState) => {
		dispatch(request(uploadFileConstants.UploadFiles.REQUEST))
		const fd = new FormData()
		getState().fileReducer.chosenFiles.forEach((file) => {
					fd.append("Files", file, file.name)
				})
		api.UploadFiles(fd)
			.then(res => {
				dispatch(success(uploadFileConstants.UploadFiles.SUCCESS, res))
			})
			.catch(err => {
				dispatch(failure(uploadFileConstants.UploadFiles.FAILURE, {err}))
			})
	}
}

function ClearUploadFielIds(){
	return (dispatch) => dispatch({ type: uploadFileConstants.UploadFiles.CLEAR })
}

function CreateAppeal(params){
	const dispatchObj = {
		constants : appealsConstants.CreateAppeal,
		service   : {
			func   : api.CreateAppeal,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function regAppeal(params){
	const dispatchObj = {
		constants : appealsConstants.RegAppeal,
		service   : {
			func   : api.RegAppeal,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function ClearCreateResult(){
	return (dispatch) => dispatch({ type: appealsConstants.ClearCreateResult.CLEAR })
}

const getDates = (name, array) => {
	return array?.reduce(
    (accum, next, index) => {
			let date = null
			if(next){
				if(index == 1){
					date = next
					date.set('hour', 23);
					date.set('minute', 59);
					date.set('second', 59);
					date.set('millisecond', 999);
				} else {
					date = next
					date.set('hour', 0);
					date.set('minute', 0);
					date.set('second', 0);
					date.set('millisecond',0);
				}
			}

    	return {
    		...accum,
    		[`${ name }[${ index }]`]: new Date(date)
    	}
    },
    {}
  )
}

function getListRA(params, tableIndex, setDefault = false, exportExcel = false,  isSaveFilters = true,){

	const applicantTypes = params.filters?.applicantType?.reduce(
    (accum, next, index) => {
    	return {
    		...accum,
    		[`ApplicantTypes[${ index }]`]: next
    	}
    },
    {}
  )
	const appealTypes = params.filters?.reAppealType?.reduce(
    (accum, next, index) => {
    	return {
    		...accum,
    		[`AppealTypes[${ index }]`]: next
    	}
    },
    {}
  )

  const appealFormTypes = params.filters?.reFormType?.reduce(
	(accum, next, index) => {
    	return {
    		...accum,
    		[`AppealFormTypes[${ index }]`]: next
    	}
    },
    {}
  )

	const statusCodes = params.filters?.statusCodes?.reduce((accum, next, index) => {
		return {
			...accum,
			[`StatusCodes[${ index }]`]: next
		}
	}, {})
	const ReAppealViewTypesIds = params.filters?.reAppealViewTypeId?.reduce(
    (accum, next, index) => {
    	return {
				...accum,
    		[`ReAppealViewTypesIds[${ index }]`]: next
    	}
    },
		{}
  )
	let newParams = {
		...params
	}
	 if(!isSaveFilters){
	 	newParams = {
	 		...newParams,
	 		filters: {
	 			...newParams.filters,
				statusesForAppealsExport: newParams.filters.statusCodes,
	 			statusCodes: []
	 		}
	 	}
	 }

	const serverParams = {
		page                      : params.pagination.current,
		pageSize                  : params.pagination.pageSize,
		regNumber                 : params.filters?.regNumber,
		reOrgId                   : params.filters?.whereSubmit ? params.filters?.whereSubmit[0].id : null,
		theme                     : params.filters?.theme?.id,
		subTheme                  : params.filters?.subTheme?.id,
		reCountryId               : params.filters?.ReCountryId,
		regionId                  : params.filters?.region,
		addressId                 : params.filters?.address,
		administrativeterritoryId : params.filters?.administrativeterritory,
		districtId                : params.filters?.district,
		indexId                   : params.filters?.index ? params.filters?.index : params.filters?.postIndex,
		house                     : params.filters?.house,
		notice                    : params.filters?.notice,
		office                    : params.filters?.office,
		sEDNumber				  : params.filters?.sEDNumber,
		redirectOrgSearch 		  : params.filters?.RedirectOrgSearch,
		isRepeated		  		  : params.filters?.isRepeated,
		isIdentical		  		  : params.filters?.isIdentical,
		isCorrespondenceTerminated: params.filters?.isCorrespondenceTerminated,
		appealContent			  : params.filters?.appealContent,
		strictSearch	  		  : params.filters?.strictSearch,
		isForeign	 	  	  	  : params.filters?.isForeign,
		applicantFullName         : params.filters?.applicantFullName,
		creationDateOrder         : params.sorter?.creationDate ? params.sorter.creationDate : null,
		endDateOrder              : params.sorter?.endDueDate ? params.sorter.endDueDate : null,
		tableIndex                : exportExcel? tableIndex: null,
		...ReAppealViewTypesIds,
		...statusCodes,
		...applicantTypes,
		...appealTypes,
		...appealFormTypes,
		...getDates('RegDate', params.filters?.regDate),
		...getDates('RegDateDue', params.filters?.regDateDue),
		...getDates('DateExecute', params.filters?.dateExecute),
		...getDates('DateExecuteDue', params.filters?.dateExecuteDue)
	}
	const dispatchObj = {
		constants      : !exportExcel? appealsConstants.getListRA : exportToExcelConstants.ExportListToExcel,
		reqParams      : newParams,
		sucFunctionDis : setDefault ? setDefaultPage() : null,
		service        : {
			func   : !exportExcel? tableIndex === 1 ? api.GetListInRa : tableIndex == 2 ? api.GetListRa : tableIndex == 3 ? api.GetListControlRa : tableIndex == 5 ? api.GetListAppointRa : api.GetListInRa : api.ExportListToExcel,
			params : serverParams
		}
	}

	return defAction(dispatchObj)
}

function setRARegForm(id){
	return (dispatch) => dispatch({
		type    : appealsConstants.SET_RA_REGFORM,
		payload : id
	})
}

function recallAppeal(params){
	const dispatchObj = {
		constants : appealsConstants.RecallAppeal,
		reqParams : params,
		service   : {
			func   : api.RecallAppeal,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function redirectAppeal(params, reqParams){
	const dispatchObj = {
		constants : appealsConstants.RedirectAppeal,
		reqParams : reqParams,
		service   : {
			func   : api.RedirectAppeal,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function getHeadViceOrg(params){
	const dispatchObj = {
		constants : appealsConstants.GetHeadViceOrg,
		service   : {
			func   : api.GetHeadViceOrg,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function createRedirectAppealForm(params){
	const dispatchObj = {
		constants : appealsConstants.CreateRedirectAppealForm,
		service   : {
			func   : api.CreateRedirectAppealForm,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function createAppealRequestForm(params){
	const dispatchObj = {
		constants : appealsConstants.CreateAppealRequestForm,
		service   : {
			func   : api.CreateAppealRequestForm,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function createAppealResponseForm(params){
	const dispatchObj = {
		constants : appealsConstants.CreateAppealResponseForm,
		service   : {
			func   : api.CreateAppealResponseForm,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function getAppealRequestForms(params){
	const dispatchObj = {
		constants : appealsConstants.GetAppealRequestForms,
		service   : {
			func   : api.GetAppealRequestForms,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function getAppealRequestFormsPaged(params){
	const dispatchObj = {
		constants : appealsConstants.GetAppealRequestFormsPaged,
		service   : {
			func   : api.GetAppealRequestFormsPaged,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function downloadAppealRequestFormFile(params){
	const dispatchObj = {
		constants : appealsConstants.DownloadAppealRequestFormFile,
		service   : {
			func   : api.DownloadAppealRequestFormFile,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function changeRedirectAppealForm(params){
	const dispatchObj = {
		constants : appealsConstants.ChangeRedirectAppealForm,
		service   : {
			func   : api.ChangeRedirectAppealForm,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function getRedirectAppealForms(params){
	const dispatchObj = {
		constants : appealsConstants.GetRedirectAppealForms,
		service   : {
			func   : api.GetRedirectAppealForms,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function redirectAppealFromForm(params, reqParams){
	const dispatchObj = {
		constants : appealsConstants.RedirectAppealFromForm,
		reqParams : reqParams,
		service   : {
			func   : api.RedirectAppealFromForm,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function clearRedirectAppealFromForm(){
	return dispatch => dispatch({ type: appealsConstants.RedirectAppealFromForm.CLEAR })
}
	
function withoutConsiderationAppeal(params){
	const dispatchObj = {
		constants : appealsConstants.WCAppeal,
		reqParams : params,
		service   : {
			func   : api.WithoutConsiderationAppeal,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function clearWCAppeal(params){
	return (dispatch) => dispatch({ type    : appealsConstants.WCAppeal.CLEAR,
		payload : params })
}

function GetRAById(params){
	const dispatchObj = {
		constants : appealsConstants.GetReOrgAppealById,
		service   : {
			func   : api.GetReOrgAppealById,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function GetRA_AById(params){
	const dispatchObj = {
		constants : appealsConstants.GetReOrgAppealById,
		service   : {
			func   : api.GetReOrgAppeal_Appeal,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function ClearReOrgAppeal(){
	return dispatch => dispatch({ type: appealsConstants.GetReOrgAppealById.CLEAR })
}

function getListPrevAppeals(params){
	const dispatchObj = {
		constants : appealsConstants.getListPrevAppeals,
		service   : {
			func   : api.GetListPrevAppeals,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function gerRedirectRAs(params){
	const dispatchObj = {
		constants : appealsConstants.GetRedirectRAs,
		service   : {
			func   : api.GetRedirectRAs,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function GetListAppeal(params){
	const dispatchObj = {
		constants : appealsConstants.GetListAppeal,
		service   : {
			func   : api.GetListAppeal,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function GetAppealById(params){
	const dispatchObj = {
		constants : appealsConstants.GetAppealById,
		service   : {
			func   : api.GetAppealById,
			params : params
		}
	}
	return defAction(dispatchObj)
}
function ClearGetAppealById(){
	return (dispatch) => dispatch({ type: appealsConstants.GetAppealById.CLEAR })
}

function GetMinReOrgAppealInfoByAppealId(params){
	const dispatchObj = {
		constants : appealsConstants.GetMinReOrgAppealInfoByAppealId,
		service   : {
			func   : api.GetMinReOrgAppealInfoByAppealId,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function ClearMinReOrgAppealInfoByAppealId(){
	return (dispatch) => dispatch({ type: appealsConstants.GetMinReOrgAppealInfoByAppealId.CLEAR })
}

function GetAppealFilesByAppealId(params){
	const dispatchObj = {
		constants : appealsConstants.GetAppealFilesByAppealId,
		service   : {
			func   : api.GetAppealFilesByAppealId,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function DownloadAppealFile(params, fileName, fileExtension){
	const dispatchObj = {
		constants : appealsConstants.DownloadAppealFile,
		service   : {
			func   : api.DownloadAppealFile,
			params : params
		},
		sucFunction: (res) => {
			downloadFile(res,{fileName: fileName, fileExtension: fileExtension})
		}
	}
	return defAction(dispatchObj)
}

function DownloadAllAppealFiles(params, fileName){
	const dispatchObj = {
		constants : appealsConstants.DownloadAllAppealFiles,
		service   : {
			func   : api.DownloadAllAppealFiles,
			params : params
		},
		sucFunction: (res) => {
			downloadFile(res,{fileName: fileName, fileExtension: '.zip'})
		}
	}
	return defAction(dispatchObj)
}

function DownloadAppealAnswerFile(params, fileName, fileExtension){
	const dispatchObj = {
		constants : appealsConstants.DownloadAppealAnswerFile,
		service   : {
			func   : api.DownloadAppealAnswerFile,
			params : params
		},
		sucFunction: (res) => {
			downloadFile(res,{fileName: fileName, fileExtension: fileExtension})
		}
	}
	return defAction(dispatchObj)
}

function ClearAppealFilesByAppealId(){
	return (dispatch) => dispatch({ type: appealsConstants.GetAppealFilesByAppealId.CLEAR })
}

function getListPrevAppealsForDisciplinaryActions(params){
	const dispatchObj = {
		constants : appealsConstants.GetListPrevAppealsForDisciplinaryActions,
		service   : {
			func   : api.getListPrevAppealsForDisciplinaryActions,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function checkPreviousAppeal(params){
	const dispatchObj = {
		constants : appealsConstants.CheckPreviousAppeal,
		service   : {
			func   : api.CheckPreviousAppeal,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function finaliseAppeal(params){
	const dispatchObj = {
		constants : appealsConstants.FinaliseAppeal,
		reqParams : params,
		service   : {
			func: api.FinaliseAppeal,
			params
		}
	}

	return defAction(dispatchObj)
}

function editReviewProcess(params){
	const dispatchObj = {
		constants : appealsConstants.EditReviewProcess,
		service   : {
			func: api.EditReviewProcess,
			params
		}
	}
	return defAction(dispatchObj)
}

function CreateOrgAppeal(params){
	const dispatchObj = {
		constants : appealsConstants.CreateOrgAppeal,
		service   : {
			func   : api.CreateOrgAppeal,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function EditOrgAppeal(params){
	const dispatchObj = {
		constants : appealsConstants.EditOrgAppeal,
		service   : {
			func   : api.EditOrgAppeal,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function EditElectronicOrgAppeal(params){
	const dispatchObj = {
		constants : appealsConstants.EditElectronicOrgAppeal,
		service   : {
			func   : api.EditElectronicOrgAppeal,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function GetAnswerFilesByAppealId(params){
	const dispatchObj = {
		constants : appealsConstants.GetAnswerFilesByAppealId,
		service   : {
			func: api.GetAnswerFilesByAppealId,
			params
		}
	}

	return defAction(dispatchObj)
}

function ClearAnswerFilesByAppealId(){
	return (dispatch) => dispatch({ type: appealsConstants.GetAnswerFilesByAppealId.CLEAR })
}

function GetAppealChangeHistory(params){
	const dispatchObj = {
		constants : appealsConstants.GetAppealChangeHistory,
		service   : {
			func   : api.GetAppealChangeHistory,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function downloadAppealTransferTransmittalFile(values){
	const dispatchObj = {
		constants : appealsConstants.DownloadAppealTransferTransmittalFile,
		service   : {
			func   : api.DownloadAppealTransferTransmittalFile,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function downloadRedirectAppealFormFile(values){
	const dispatchObj = {
		constants : appealsConstants.DownloadRedirectAppealFormFile,
		service   : {
			func   : api.DownloadRedirectAppealFormFile,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function GetRepeatAppeals(values){
	const dispatchObj = {
		constants : appealsConstants.GetRepeatAppeals,
		service   : {
			func   : api.GetRepeatAppeals,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getRecallByRegistratorFiles(values){
	const dispatchObj = {
		constants : appealsConstants.GetRecallByRegistratorFiles,
		service   : {
			func   : api.getRecallByRegistratorFiles,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clearRecallByRegistratorFiles(){
	return dispatch => dispatch({ type: appealsConstants.GetRecallByRegistratorFiles.CLEAR })
}


function recallByRegistrator(values){
	const dispatchObj = {
		constants : appealsConstants.RecallByRegistrator,
		service   : {
			func   : api.recallByRegistrator,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clearRecallByRegistrator(){
	return dispatch => dispatch({ type: appealsConstants.RecallByRegistrator.CLEAR })
}


function ClearRepeatAppeals(){
	return (dispatch) => dispatch({ type: appealsConstants.GetRepeatAppeals.СLEAR })
}

function excelFileClear(){
	return (dispatch) => dispatch({ type: appealsConstants.ExportListToExcel.СLEAR })
}

function takeIntoAccount(params){
	const dispatchObj = {
		constants: appealsConstants.TakeIntoAccount,
		service:{
			func: api.TakeIntoAccount,
			params
		}
	}

	return defAction(dispatchObj)
}

function clearTakeIntoAccount(){
	return dispatch => dispatch({ type: appealsConstants.TakeIntoAccount.CLEAR })
}

function downloadRecallBasisFile(params) {
	const dispatchObj = {
		constants: appealsConstants.DownloadRecallBasisFile,
		service: {
			func: api.downloadRecallBasisFile,
			params
		}
	}

	return defAction(dispatchObj)
}

function getReOrgAppealConvertFile(params) {
	const dispatchObj = {
		constants: appealsConstants.GetReOrgAppealConvertFile,
		service: {
			func: api.GetReOrgAppealConvertFile,
			params
		}
	}

	return defAction(dispatchObj)
}

function clearConvertFile(){
	return dispatch => dispatch({ type: appealsConstants.GetReOrgAppealConvertFile.CLEAR })
}

function getRedirectAccompanyingLetterFile(params, fileName, toDownload) {
	const dispatchObj = {
		constants: appealsConstants.GetRedirectAccompanyingLetterFile,
		service: {
			func: api.getRedirectAccompanyingLetterFile,
			params
		},
		sucFunction: (res) => {
			toDownload ?  downloadFile(res,{fileName: fileName, fileExtension: '.docx'}) : null
		}
	}

	return defAction(dispatchObj)
}

function clearAccompanyingLetterFile(){
	return dispatch => dispatch({ type: appealsConstants.GetRedirectAccompanyingLetterFile.CLEAR })
}

function getPotentialOrgAppealTerritories(values){
	const dispatchObj = {
		constants : appealsConstants.GetPotentialOrgAppealTerritories,
		service   : {
			func   : api.getPotentialOrgAppealTerritories,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clearPotentialReOrgAppealTerritories(){
	return dispatch => dispatch({ type: appealsConstants.GetPotentialOrgAppealTerritories.CLEAR })
}

function getAllReOrgAppealTerritories(values){
	const dispatchObj = {
		constants : appealsConstants.GetAllReOrgAppealTerritories,
		service   : {
			func   : api.getAllReOrgAppealTerritories,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function downloadAdditionalOrderMessageFiles(params, fileName){
	const dispatchObj = {
		constants : appealsConstants.DownloadAdditionalOrderMessageFiles,
		service   : {
			func   : api.downloadAdditionalOrderMessageFiles,
			params : params
		},
		sucFunction: (res) => {
			downloadFile(res, {fileName, fileExtension: '.zip'})
		}
	}
	return defAction(dispatchObj)
}

function downloadAdditionalOrderMessageFile(params, fileName, fileExtension){
	const dispatchObj = {
		constants : appealsConstants.DownloadAdditionalOrderMessageFile,
		service   : {
			func   : api.downloadAdditionalOrderMessageFile,
			params : params
		},
		sucFunction: (res) => {
			downloadFile(res, {fileName, fileExtension})
		}
	}
	return defAction(dispatchObj)
}

function generateTransmittalLetterFile(params, fileName){
	const dispatchObj = {
		constants : appealsConstants.GenerateTransmittalLetterFile,
		service   : {
			func   : api.generateTransmittalLetterFile,
			params : params
		},
		sucFunction: (res) => {
			downloadFile(res,{fileName: fileName, fileExtension: '.docx'})
		}
	}

	return defAction(dispatchObj)
}